/**
 * Mobile Menu Drawer - Reise Style
 * Gerencia abertura/fechamento e navegação do menu lateral mobile
 */

class MobileMenuDrawer {
  constructor() {
    this.drawer = document.getElementById('mobileMenuDrawer');
    this.menuButton = document.getElementById('mobileMenuButton');
    this.closeButton = document.getElementById('mobileMenuClose');
    this.overlay = document.getElementById('mobileMenuOverlay');
    
    if (!this.drawer || !this.menuButton) {
      console.warn('Mobile menu elements not found');
      return;
    }
    
    this.init();
  }
  
  init() {
    // Event listeners para abrir/fechar
    this.menuButton.addEventListener('click', () => this.open());
    this.closeButton.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());
    
    // Fechar com ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) {
        this.close();
      }
    });
    
    // Gerenciar submenus
    this.initSubmenus();
  }
  
  open() {
    this.drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  
  close() {
    this.drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    
    // Fechar todos os submenus abertos
    const openSubmenus = this.drawer.querySelectorAll('.mobile-submenu.is-active');
    openSubmenus.forEach(submenu => {
      submenu.classList.remove('is-active');
    });
  }
  
  initSubmenus() {
    // Botões para abrir submenus
    const submenuToggles = this.drawer.querySelectorAll('[data-submenu-toggle]');
    submenuToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const submenu = toggle.nextElementSibling;
        if (submenu && submenu.classList.contains('mobile-submenu')) {
          submenu.classList.add('is-active');
        }
      });
    });
    
    // Botões para voltar dos submenus
    const backButtons = this.drawer.querySelectorAll('[data-submenu-back]');
    backButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const submenu = button.closest('.mobile-submenu');
        if (submenu) {
          submenu.classList.remove('is-active');
        }
      });
    });
  }
}

/**
 * Mobile Search Drawer - Reise Style
 * Gerencia abertura/fechamento do drawer de busca mobile
 */
class MobileSearchDrawer {
  constructor() {
    this.drawer = document.getElementById('mobileSearchDrawer');
    this.searchTrigger = document.getElementById('mobileSearchTrigger');
    this.closeButton = document.getElementById('mobileSearchClose');
    this.overlay = document.getElementById('mobileSearchOverlay');
    this.searchInput = this.drawer?.querySelector('.mobile-search-input');
    
    if (!this.drawer || !this.searchTrigger) {
      console.warn('Mobile search elements not found');
      return;
    }
    
    this.init();
  }
  
  init() {
    // Event listeners para abrir/fechar
    this.searchTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.open();
    });
    
    this.closeButton.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());
    
    // Fechar com ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.drawer.classList.contains('active')) {
        this.close();
      }
    });
  }
  
  open() {
    this.drawer.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    // Focar no input de busca após abrir
    setTimeout(() => {
      if (this.searchInput) {
        this.searchInput.focus();
      }
    }, 300);
  }
  
  close() {
    this.drawer.classList.remove('active');
    document.body.style.overflow = '';
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MobileMenuDrawer();
    new MobileSearchDrawer();
  });
} else {
  new MobileMenuDrawer();
  new MobileSearchDrawer();
}

